import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import SupportTicketLink from '../../../../common/components/SupportTicketLink';
import SourceFileLink from './SourceFileLink';

const PowerBiNoContentMessage = ({ item = {}, isPwcUser, errorCode, t }) => {
  const { tab } = item;

  const getPwcUserMessage = () => {
    return (
      <>
        <div className="content-section">
          <div>
            <Trans
              i18nKey="powerBiTabReNamed"
              components={[<SourceFileLink item={item} key={0} />]}
              values={{ tabName: tab }}
            />
          </div>
        </div>
        <div className="content-section">
          <Trans
            i18nKey={
              errorCode
                ? 'ifIssueContinueCreateTicketForthisIssueWithError'
                : 'ifIssueContinueCreateTicketForthisIssue'
            }
            components={[<SupportTicketLink key="0" />]}
            values={{ errorCode }}
          />
        </div>
      </>
    );
  };

  const getClientMessage = () => {
    return (
      <>
        <div className="content-section">{t('powerBiTabReNamedClient')}</div>
        <div className="content-section">
          <Trans
            i18nKey={
              errorCode
                ? 'pleaseCreateTicketForthisIssueWithError'
                : 'pleaseCreateTicketForthisIssue'
            }
            components={[<SupportTicketLink key="0" />]}
            values={{ errorCode }}
          />
        </div>
      </>
    );
  };

  return (
    <>
      {isPwcUser && getPwcUserMessage()}
      {!isPwcUser && getClientMessage(0)}
    </>
  );
};

export default withTranslation()(PowerBiNoContentMessage);
